import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import { Button, IconButton, Tooltip, makeStyles } from '@material-ui/core';
import ServicoIcon from 'app/assets/icon/ServicoIcon';
import React, { useContext } from 'react';
import { FaChartBar } from 'react-icons/fa';
import { GestaoEnvioContext } from '../../GestaoEnvioContext';
import { GestaoEnvioModais } from '../modal/GestaoEnvioModais';

const useStyles = makeStyles({
  searchBarContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    maxWidth: '512px',
  },
  link: {
    color: '#53c4e6',
    fontWeight: '600',
    textTransform: 'none',
  },
  buttonChartContainer: {
    color: 'white',
    backgroundColor: 'rgba(88, 144, 170, 0.8)',
    '&:hover': {
      backgroundColor: 'rgba(88, 144, 170, 1)',
      boxShadow: 'none',
      borderColor: 'rgba(88, 144, 170, 0)',
    },
    '&:active': {
      boxShadow: 'none',
      backgroundColor: 'rgba(88, 144, 170, 0.9)',
      borderColor: 'rgba(88, 144, 170, 0)',
    },
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(88, 144, 170,0.9)',
      borderColor: 'rgba(88, 144, 170, 0)',
    },
  },
  buttonIconBoleto: {
    marginRight: '20px',
  },
});

const GestaoEnvioHeader = () => {
  const [, setSearch] = useContext(GestaoEnvioContext).search;
  const [, setModal] = useContext(GestaoEnvioContext).modal;

  const styles = useStyles();

  const handleOpenBuscaAvancada = () => {
    setModal(GestaoEnvioModais.buscaAvancada);
  };

  const handleOpenGraficos = () => {
    setModal(GestaoEnvioModais.indicadores);
  };

  return (
    <PageHeader
      title="Gestão de envios"
      icon={<ServicoIcon />}
      button={
        <Tooltip title="Exibir indicadores">
          <IconButton className={styles.buttonChartContainer} onClick={handleOpenGraficos}>
            <FaChartBar className="stepVisualizarDashboards" />
          </IconButton>
        </Tooltip>
      }
    >
      <div className={styles.searchBarContainer}>
        <div className="flex items-center w-full max-w-512 stepBarraPesquisa">
          <SearchBar onChange={setSearch} placeholder="Pesquise pelo cliente" />
        </div>
        <div className="stepBuscaAvancada">
          <Button className={styles.link} onClick={handleOpenBuscaAvancada}>
            Busca avançada
          </Button>
        </div>
      </div>
    </PageHeader>
  );
};

export default GestaoEnvioHeader;
